import {
  BreakPointCondition,
  UI,
  useBreakpointIf,
  HStack,
  Stack,
  VStack,
} from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import {
  FundsAssetsQueryData,
  ClubsAssetsQueryData,
} from '../../../../../../../store/customerAssetDetail/selector';
import { FundsAssetsNoteItem } from '../../../../../../../store/customerAssetDetail/types';

export interface FundsSecondaryInfoProps {
  product: Utils.ArrayElement<NonNullable<FundsAssetsQueryData | ClubsAssetsQueryData>>;
}

export const FundsSecondaryInfo: React.FC<FundsSecondaryInfoProps> = ({ product }) => {
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const getInfos = (note: FundsAssetsNoteItem) => [
    { label: 'Data de cotização', value: note.implementationDateNormalized },
    { label: 'Valor histórico', value: note.historicalValueNormalized },
    { label: 'Qtd. cotas', value: note.quotaAmountNormalized },
    { label: 'Cota aplicação', value: note.quotaPurchasedValueNormalized },
    { label: 'Cota atual', value: product.quotaCurrentValueNormalized },
    { label: 'Valor bruto', value: note.grossValueNormalized },
    { label: 'IOF', value: note.iofValueNormalized },
    { label: 'IR', value: note.irValueNormalized },
    { label: 'Valor líquido', value: note.netValueNormalized },
  ];

  const renderInfos = (note: FundsAssetsNoteItem) => {
    const infos = getInfos(note);
    if (isMobile) {
      return (
        <VStack space={Spacing['stack.nano']}>
          {infos.map((item) => (
            <HStack justifyContent="space-between" key={item.label} w="full">
              <UI.Text color="neutral.black" variant="semibold">
                {item.label}
              </UI.Text>
              <UI.Text color="neutral.darkest">{item.value}</UI.Text>
            </HStack>
          ))}
        </VStack>
      );
    }

    const columns = isTablet ? Math.ceil(infos.length / 2) : infos.length;
    return (
      <FlatList
        key={`flatList-fund-detail${isTablet}`}
        style={{ overflow: 'visible' }}
        columnWrapperStyle={{ paddingVertical: Utils.Token.ToInt(Spacing, 'stack.nano') }}
        keyExtractor={(item) => `${item.label}-${isTablet}`}
        data={infos}
        renderItem={({ item }) => (
          <VStack space={Spacing['stack.quarck']} w={`${100 / columns}%`}>
            <UI.Text variant="semibold">{item.label}</UI.Text>
            <UI.Text color="neutral.darkest">{item.value}</UI.Text>
          </VStack>
        )}
        numColumns={columns}
      />
    );
  };

  return (
    <VStack p={Spacing['inset.nano']} space={Spacing['stack.xxxs']} w="full">
      {product.notesNormalized.map((note) => (
        <Stack key={note.noteNumber} space={Spacing['stack.xxxs']}>
          {!isMobile && <Box w="full" h="1px" bgColor={Color['neutral.lightest']} />}
          <VStack p={Spacing['inset.xs']} bgColor={Color.background} borderRadius={BoxBorder.heavy}>
            {renderInfos(note)}
          </VStack>
        </Stack>
      ))}
    </VStack>
  );
};
